import { render } from "./PostListInput.vue?vue&type=template&id=679317f8&scoped=true"
import script from "./PostListInput.vue?vue&type=script&lang=js"
export * from "./PostListInput.vue?vue&type=script&lang=js"

import "./PostListInput.vue?vue&type=style&index=0&id=679317f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679317f8"]])

export default __exports__